var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"meter-online-fault-panel"},[_c('div',{staticClass:"panel-header"},[_c('h3',{staticClass:"panel-title"},[_vm._v(_vm._s(_vm.$t('水表在线率')))])]),_c('div',{staticClass:"panel-body"},[_c('div',{ref:"chart",staticClass:"chart-container"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }